import { render, staticRenderFns } from "./MarketHistory.vue?vue&type=template&id=1f803e48"
import script from "./MarketHistory.vue?vue&type=script&lang=js"
export * from "./MarketHistory.vue?vue&type=script&lang=js"
import style0 from "./MarketHistory.vue?vue&type=style&index=0&id=1f803e48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports